import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OperacionService {
  token: string = '';
  baseUrl = environment.apiEndpoint;

  constructor(private http: HttpClient) {
    this.token = environment.token;
  }

  private header(accessToken: string) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "Accept": "application/json",
      "Authorization": "Bearer " + accessToken
    });
    return headers;
  }

  getOperacion(): Observable<any> {
    return this.http.get(this.baseUrl + 'poaOperaciones', { headers: this.header(this.token) });
  }

  getOperacionById(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'poaOperacion/' + id, { headers: this.header(this.token) });
  }

  postOperacion(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'poaOperacion', bodyString, { headers: this.header(this.token) });
  }

  putOperacion(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'poaOperacion', bodyString, { headers: this.header(this.token) });
  }

  deleteOperacion(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'poaOperacion/' + id, { headers: this.header(this.token) });
  }

  getUnidadesTechoByOperacionId(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'unidadesTechoByOperacionId/' + id, { headers: this.header(this.token) });
  }

  getFuentesTechoByOperacionId(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'poaFuentesTechoByOperacionId/' + id, { headers: this.header(this.token) });
  }

  getListOperacionesByAeId(id: string): Observable<any> {
    return this.http.get(this.baseUrl + 'operacionesByAeId/' + id, { headers: this.header(this.token) });
  }

  getListoperacionesByTechoId(id: string): Observable<any> {
    return this.http.get(this.baseUrl + 'operacionesByTechoId/' + id, { headers: this.header(this.token) });
  }

  getListOperacionesByIntId(id: string): Observable<any> {
    return this.http.get(this.baseUrl + 'operacionesByIntervencionId/' + id, { headers: this.header(this.token) });
  }  

  deleteIndicadorOperacion(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'poaIndicadorOperacion/' + id, { headers: this.header(this.token) });
  }

  putIndicadorOperacion(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'poaIndicadorOperacion', bodyString, { headers: this.header(this.token) });
  }

  postIndicadorOperacion(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'poaIndicadorOperacion', bodyString, { headers: this.header(this.token) });
  }

  // getListOperacionesByIntIdA(id: string, tipo: number): Observable<any> {
  //   return this.http.get(this.baseUrl + 'operacionesByIntervencionIdAsignacion/' + id + '/' + tipo, { headers: this.header(this.token) });
  // }

  getListOperacionesByTechoId(id: string): Observable<any> {
    return this.http.get(this.baseUrl + 'operacionesByIntervencionByTechoId/' + id, { headers: this.header(this.token) });
  }

  
  getListOperacionesByIntIdA2(id: string): Observable<any> {
    return this.http.get(this.baseUrl + 'operacionesByIntervencionIdAsignacion2/' + id , { headers: this.header(this.token) });
  }

  deleteProgramacion(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'deleteProgramacion/' + id, { headers: this.header(this.token) });
  }
 
  deleteProgramacionAcp(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'deleteProgramacionAcp/' + id, { headers: this.header(this.token) });
  }
  
}
